import { t } from 'i18next';
import { SocialLoginBtnProps } from './type';

export default function SocialLoginBtn ({
  onClick,
  backgroundColor = 'bg-white',
  fontColor = 'text-gray-black',
  additionalStyle,
  icon,
  text,
}: SocialLoginBtnProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center ${backgroundColor} md:w-[357px] md:h-[54px] md:rounded-full md:px-7 ${additionalStyle}
        w-[48px] h-[48px] rounded-[8px] `}
    >
      {icon}
      <span className={`hidden md:block px-5 ${fontColor} text-[16px] font-medium font-weight-600 leading-[150%]`}>
        {t(`login.${text}`)}
      </span>
    </button>
  );
}